export default __webpack_public_path__ + "static/media/HENNESSY_3.2ba77149.gif";